(function () {
  'use strict';

  var el = document.querySelector('[data-main-product-recently-viewed-id]');
  if (!el) return;

  var productId = parseInt(el.getAttribute('data-main-product-recently-viewed-id'), 10);
  if (!productId) return;

  try {
    var recentlyViewedProducts = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
    recentlyViewedProducts = recentlyViewedProducts.filter(function (item) {
      return item !== productId;
    });
    recentlyViewedProducts.unshift(productId);
    localStorage.setItem('theme:recently-viewed-products', JSON.stringify(recentlyViewedProducts));
  } catch (e) {
    /* Safari private mode, etc. */
  }
})();
